export const sites = {
workspace: {
assets: "Anlagen",
sites: "Standorte",
},
list: {
  showAllSites: "Alle Standorte anzeigen",
  emptyArchivedSub: "Archivierte Standorte werden hier aufbewahrt. Öffnen Sie einen, um ihn wiederherzustellen.",
  emptyArchivedTitle: "Keine archivierten Standorte",
  queueArchived: "Archiviert",
title: "Standorte",
subtitle_one: "{{count}} Standort",
subtitle_other: "{{count}} Standorte",
searchPlaceholder: "Standorte suchen…",
searchA11y: "Standorte durchsuchen",
refine: "Filtern",
refineSheetTitle: "Standorte filtern",
addSite: "Standort hinzufügen",
queueAll: "Alle",
queueAttention: "Gefährdet",
queueDevelopment: "In Entwicklung",
nextReviewAtRisk_one: "{{count}} gefährdete Anlage überprüfen",
nextReviewAtRisk_other: "{{count}} gefährdete Anlagen überprüfen",
nextOpenJobs_one: "{{count}} offener Auftrag",
nextOpenJobs_other: "{{count}} offene Aufträge",
nextOpenChecks_one: "{{count}} offene Prüfung",
nextOpenChecks_other: "{{count}} offene Prüfungen",
a11yAssets_one: "{{count}} Anlage",
a11yAssets_other: "{{count}} Anlagen",
emptyTitle: "Noch keine Standorte",
createSite: "Standort anlegen",
emptySub: "Erstellen Sie einen Standort, um Anlagen nach Ort oder Portfolio zu gruppieren.",
emptyFilterTitle: "Keine passenden Standorte",
emptyFilterSub: "Versuchen Sie andere Suchbegriffe oder setzen Sie die Filter zurück.",
clearFilters: "Filter zurücksetzen",
typeChip: "Typ",
lifecycleChip: "Status",
sortChip: "Sortieren",
sortNameAsc: "Name A–Z",
sortNameDesc: "Name Z–A",
sortNewest: "Neueste",
sortOldest: "Älteste",
insightAttention: "{{count}} gefährdet",
nextAllClear: "Keine offene Arbeit",
nextAddAssets: "Fügen Sie diesem Standort Anlagen hinzu",
pillAsset: "Anlage",
pillAssets: "Anlagen",
pillOnTrack: "Auf Kurs",
pillJobs: "Arbeitsaufträge",
pillChecks: "Prüfungen",
exportCsv: "CSV exportieren",
exportCsvA11y: "Standorte als CSV herunterladen",
viewCards: "Kartenansicht",
viewTable: "Tabellenansicht",
openSite: "Standort öffnen",
unassigned: "Nicht zugewiesen",
managingTeam: "Verantwortliches Team",
colSite: "Standort",
colType: "Typ",
colTeam: "Team",
colAssets: "Anlagen",
colJobs: "Aufträge",
colRisk: "Gefährdet",
colStatus: "Status",
unknownSite: "Unbekannter Standort",
loadErrorTitle: "Wir konnten Ihre Standorte nicht laden",
loadErrorBlockedTitle: "Standorte können nicht angezeigt werden",
viewLabel: "Ansicht",
scopeLabel: "Bereich",
csvHeaderName: "Name",
csvHeaderCode: "Referenz",
csvHeaderLifecycle: "Status",
csvHeaderAddress: "Adresse",
},
detail: {
byPlaceTitle: "Nach Gebäude",
byPlaceOpenA11y: "{{name}} öffnen",
byPlaceInside_one: "{{count}} darin",
byPlaceInside_other: "{{count}} darin",
byPlaceOpenJobs_one: "{{count}} offener Auftrag",
byPlaceOpenJobs_other: "{{count}} offene Aufträge",
byPlaceDue_one: "{{count}} Termin fällig",
byPlaceDue_other: "{{count}} Termine fällig",
byPlaceAtRisk_one: "{{count}} mit hohem Risiko",
byPlaceAtRisk_other: "{{count}} mit hohem Risiko",
  noWorkNoAssets: "Arbeit erscheint hier, sobald der Standort Anlagen hat. Fügen Sie eine hinzu oder verschieben Sie eine hierher.",
  assignSubtitleTeam: "Wählen Sie eine Anlage, die hierher soll. Sie verlässt ihren bisherigen Standort und geht an {{team}}.",
  assignSubtitle: "Wählen Sie eine Anlage, die hierher soll. Sie verlässt ihren bisherigen Standort.",
  assignFailedBody: "Die Anlage wurde nicht verschoben. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  assignRefusedBody: "Sie können diese Anlage nicht verschieben. Fragen Sie die verantwortliche Person oder einen Admin.",
  assignFailedTitle: "Anlage nicht verschoben",
  assignedFallbackAsset: "Die Anlage",
  assignedToast: "{{asset}} wurde nach {{site}} verschoben.",
  archivedBanner: "Dieser Standort ist archiviert und ausgeblendet. Stellen Sie ihn wieder her, um ihn erneut zu nutzen.",
  archivedPill: "Archiviert",
  restoredToast: "{{name}} wiederhergestellt. Er ist wieder in Ihren Standorten.",
  archivedToast: "{{name}} archiviert. Sie finden ihn unter Standorte → Archiviert.",
loading: "Standort wird geladen…",
addAsset: "Anlage hinzufügen",
createAsset: "Anlage hinzufügen",
assignAsset: "Anlage zuweisen",
assignExistingAsset: "Vorhandene Anlage zuweisen",
siteOptions: "Standortoptionen",
edit: "Bearbeiten",
tabOverview: "Übersicht",
tabDetails: "Details",
tabAssets: "Anlagen",
tabWork: "Arbeit",
tabReports: "Berichte",
tabEsg: "ESG",
tabContacts: "Kontakte",
tabActivity: "Aktivität",
tabPeople: "Personen",
refine: "Verfeinern",
view: "Ansicht",
viewList: "Liste",
viewMap: "Karte",
viewNetwork: "Netzwerk",
filterAttention: "Braucht Aufmerksamkeit",
backToOverview: "Zurück zur Übersicht",
kpiAssets: "Anlagen",
kpiAtRisk: "Gefährdet",
kpiOpenJobs: "Offene Aufträge",
kpiOpenInspections: "Offene Prüfungen",
parentSite: "Übergeordneter Standort",
childSites: "Untergeordnete Standorte",
description: "Beschreibung",
noAssets: "Keine Anlagen an diesem Standort.",
noAssetsForFilter: "Keine Anlagen entsprechen diesem Filter.",
noWork: "Keine offenen Aufträge oder Prüfungen.",
noContacts: "Noch keine Kontakte verknüpft.",
noContactsNeedAssets: "Fügen Sie Anlagen hinzu, bevor Sie Kontakte verknüpfen.",
noActivity: "Keine aktuelle Aktivität.",
linkContact: "Kontakt verknüpfen",
selectAssetForContact: "Anlage für Kontakt auswählen",
linkContactTitle: "Kontakt mit Anlage am Standort verknüpfen",
cancel: "Abbrechen",
filterAll: "Alle",
openJobs: "Offene Aufträge",
openInspections: "Offene Prüfungen",
attentionAssets_one: "{{count}} Anlage erfordert Aufmerksamkeit",
attentionAssets_other: "{{count}} Anlagen erfordern Aufmerksamkeit",
openJobsCount_one: "{{count}} offener Auftrag",
openJobsCount_other: "{{count}} offene Aufträge",
assetsSectionTitle: "Anlagen an diesem Standort",
assetsSectionSub_one: "{{count}} Anlage",
assetsSectionSub_other: "{{count}} Anlagen",
filterVehicles: "Fahrzeuge",
descriptionSummary: "Standortnotizen und Kontext",
workBannerNamed: "Arbeit eingeschränkt auf {{names}}",
contactsForAsset_one: "{{count}} Kontakt",
contactsForAsset_other: "{{count}} Kontakte",
noContactsForAsset: "Noch keine Kontakte mit dieser Anlage verknüpft.",
archiveConfirmTitle: "Diesen Standort archivieren?",
archiveConfirmMessage: "Er wird in Ihren Standorten ausgeblendet. Anlagen bleiben, wo sie sind. Sie finden ihn unter Standorte → Archiviert und können ihn dort wiederherstellen.",
archive: "Archivieren",
archiveFailedTitle: "Der Standort konnte nicht archiviert werden",
archiveFailedMessage: "Der Standort wurde nicht geändert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
restore: "Standort wiederherstellen",
restoreFailedTitle: "Der Standort konnte nicht wiederhergestellt werden",
loadErrorTitle: "Wir konnten diesen Standort nicht laden",
loadErrorBlockedTitle: "Dieser Standort kann nicht angezeigt werden",
goBack: "Zurück",
notFoundTitle: "Standort nicht gefunden",
notFoundBody: "Dieser Standort wurde möglicherweise archiviert oder der Link ist veraltet.",
noAssetsForSearch: "Keine Anlagen entsprechen Ihrer Suche",
clearSearch: "Suche zurücksetzen",
searchAssetsPlaceholder: "Anlagen an diesem Standort suchen",
kpiAttention: "Handlungsbedarf",
kpiOpenChecks: "Offene Inspektionen",
kpiAssetsInfoDescription: "Diesem Standort zugewiesene Anlagen. Anlagen untergeordneter Standorte zählen dort.",
kpiAssetsInfoBasedOn_one: "{{count}} Anlage, live aus dem Anlagenregister gezählt",
kpiAssetsInfoBasedOn_other: "{{count}} Anlagen, live aus dem Anlagenregister gezählt",
kpiAttentionInfoDescription: "Anlagen an diesem Standort, deren Zustand beobachtet werden muss oder schlecht ist, oder bei denen Arbeiten überfällig sind.",
kpiAttentionInfoBasedOn: "{{count}} von {{total}} Anlagen, aus dem Live-Zustand jeder Anlage",
kpiJobsInfoDescription: "Arbeitsaufträge für Anlagen an diesem Standort, die noch nicht abgeschlossen oder überprüft sind.",
kpiJobsInfoBasedOn_one: "{{count}} offener Arbeitsauftrag für {{total}} Anlagen",
kpiJobsInfoBasedOn_other: "{{count}} offene Arbeitsaufträge für {{total}} Anlagen",
kpiChecksInfoDescription: "Inspektionen an Anlagen an diesem Standort, die noch offen sind: begonnen und nicht abgeschlossen oder geplant und noch nicht abgeschlossen.",
kpiChecksInfoBasedOn_one: "{{count}} offene Inspektion für {{total}} Anlagen",
kpiChecksInfoBasedOn_other: "{{count}} offene Inspektionen für {{total}} Anlagen",
factsTitle: "Details",
factCode: "Standortcode",
factCategory: "Kategorie",
factType: "Typ",
factStatus: "Status",
factAddress: "Adresse",
factTeam: "Zuständiges Team",
factContacts: "Kontakte",
factHolds: "Enthält",
factCreated: "Erstellt",
factUpdated: "Aktualisiert",
factNotSet: "Nicht angegeben",
factViewOnMap: "Auf der Karte anzeigen",
    tabDocuments: "Dokumente",
    factFloorArea: "Fläche",
    floorAreaValue: "{{value}} m² Fläche",
},
map: {
  unavailableSub: "Die Karte konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  addSiteAddress: "Adresse des Standorts hinzufügen",
noAssetsTitle: "Keine Anlagen an diesem Standort",
noAssetsSub: "Fügen Sie Anlagen hinzu, um sie auf der Karte zu sehen.",
noCoordinatesTitle: "Noch nichts auf der Karte",
noCoordinatesSub: "Fügen Sie die Adresse des Standorts oder seiner Anlagen hinzu, um sie hier zu sehen.",
unavailableTitle: "Karte nicht verfügbar",
coverageShown_one: "{{count}} kartierte Anlage wird angezeigt.",
coverageShown_other: "{{count}} kartierte Anlagen werden angezeigt.",
coverageHidden_one: "{{count}} ohne Koordinaten ausgeblendet.",
coverageHidden_other: "{{count}} ohne Koordinaten ausgeblendet.",
boundarySaveFailedTitle: "Die Grenze konnte nicht gespeichert werden",
boundarySaveFailedBody: "Der Umriss konnte nicht gespeichert werden.",
boundaryRedraw: "Grenze neu zeichnen",
boundaryDraw: "Grenze zeichnen",
boundaryRemove: "Entfernen",
boundarySave: "Grenze speichern",
boundaryUndo: "Rückgängig machen",
boundaryTapFirstCorner: "Tippen Sie auf die Karte, um die erste Ecke zu platzieren",
boundaryCornersAdjust: "{{count}} Ecken – ziehen Sie eine beliebige Ecke, um sie anzupassen",
boundaryCornersOfThree: "{{count}} von 3 Ecken",
},
network: {
noAssetsTitle: "Keine Anlagen zum Verbinden",
noAssetsSub: "Fügen Sie mindestens zwei Anlagen hinzu, um Beziehungen zu erkunden.",
singleAssetTitle: "Eine Anlage an diesem Standort",
singleAssetSub: "Verknüpfen Sie diese Anlage über ihre Detailseite mit anderen, um ein Netzwerk aufzubauen.",
openAsset: "Anlage öffnen",
},
assetLink: {
label: "Standort",
helper: "Der Ort, an dem sich diese Anlage befindet.",
none: "Kein Standort zugewiesen",
open: "Standort öffnen",
rowHelper: "Optional. Der Ort, an dem sich diese Anlage befindet.",
a11ySelected: "Standort: {{name}}. Standort wechseln.",
a11yUnselected: "Standort auswählen, optional",
clearSite: "Standort entfernen",
selectSite: "Standort auswählen",
},
kind: {
  status: {
    decommissioned: "Außer Betrieb",
    under_renovation: "Wird renoviert",
    partially_operational: "Teilweise in Betrieb",
    operational: "In Betrieb",
    handover: "In Übergabe",
    partially_developed: "Teilweise gebaut",
    in_development: "Im Bau",
    planned: "Geplant",
  },
  type: {
    other: "Sonstiges",
    building: "Gebäude",
    corridor: "Trasse (Straße, Schiene oder Leitung)",
    data_centre: "Rechenzentrum",
    hotel: "Hotel",
    hospital: "Krankenhaus",
    airport: "Flughafen",
    shopping_centre: "Einkaufszentrum",
    substation: "Umspannwerk",
    project_site: "Projektstandort",
    construction_site: "Baustelle",
    parking_facility: "Parkplatz",
    terminal: "Terminal",
    port: "Hafen",
    distribution_centre: "Verteilzentrum",
    warehouse: "Lagerhalle",
    workshop: "Werkstatt",
    fleet_hub: "Fuhrpark-Standort",
    garage: "Garage",
    yard: "Hof",
    depot: "Depot",
    plant: "Werk",
    factory: "Fabrik",
    industrial_park: "Industriegebiet",
    office_building: "Bürogebäude",
    campus: "Campus",
    retail_park: "Fachmarktzentrum",
    business_park: "Gewerbepark",
    scheme: "Wohnbauprojekt",
    neighbourhood: "Wohnviertel",
    estate: "Wohnsiedlung",
  },
  category: {
    other: "Sonstiges",
    mixed_use: "Gemischte Nutzung",
    healthcare: "Gesundheitswesen",
    hospitality: "Gastgewerbe",
    temporary: "Temporär / Projekt",
    infrastructure: "Infrastruktur",
    logistics: "Logistik und Lager",
    fleet_transport: "Fuhrpark und Transport",
    industrial: "Industrie",
    commercial: "Gewerbe",
    residential: "Wohnen",
  },
  statusLabel: "Status",
  typeLabel: "Was passt am besten?",
  categoryLabel: "Was für ein Ort ist das?",
},
create: {
  createdBackToAsset: "{{name}} wurde angelegt und für Ihre Anlage ausgewählt.",
  created: "{{name}} wurde angelegt. Fügen Sie hier die Anlagen hinzu.",
  unsavedGuardMessage: "Dieser Standort ist nicht gespeichert. Verlassen und die Eingaben verlieren?",
pageTitle: "Neuer Standort",
newSiteKicker: "Neuer Standort",
unnamedSite: "Unbenannter Standort",
addNotesFirstTitle: "Zuerst Notizen hinzufügen",
addNotesFirstBody: "Geben oder diktieren Sie einen kurzen Entwurf und verwenden Sie dann „Mit KI verbessern“.",
improvedSiteNotesTitle: "Verbesserte Standortnotizen",
unableToImproveNotesTitle: "Notizen können nicht verbessert werden",
improveNotesRationale: "Überprüfen Sie die verbesserten Notizen, bevor Sie sie für den Standort übernehmen.",
improveNotesFailed: "Die Notizen konnten nicht verbessert werden. Bitte versuchen Sie es erneut.",
nameRequiredTitle: "Name erforderlich",
nameRequiredBody: "Geben Sie einen Namen für den Standort ein.",
invalidTypeTitle: "Wählen Sie die Art erneut",
invalidTypeBody: "Diese Art passt nicht zum gewählten Ort. Wählen Sie eine aus der Liste.",
createFailedTitle: "Der Standort konnte nicht angelegt werden",
createFailedBody: "Der Standort wurde nicht angelegt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
labelType: "Art des Standorts",
labelLifecycle: "Status",
labelParent: "Übergeordneter Standort",
labelManagingTeam: "Verantwortliches Team",
labelAddress: "Adresse",
labelName: "Name",
labelCode: "Referenz",
fallbackDash: "—",
basicsNameLabel: "Name *",
siteNameA11y: "Name des Standorts (erforderlich)",
siteNamePlaceholder: "z.B. Oakwood Estate",
codeLabel: "Referenz (optional)",
codeHint: "Ihr eigenes Kurzzeichen für diesen Standort, falls Sie eines nutzen.",
codeA11y: "Referenz (optional)",
codePlaceholder: "z. B. NDEP-01",
parentSiteLabel: "Übergeordneter Standort",
parentSiteHelper: "Optional. Ordnen Sie ihn einer Siedlung, einem Depot oder einem Campus zu.",
managingTeamHelper: "Anlagen, die Sie diesem Standort hinzufügen, gehen an dieses Team.",
addressLabel: "Adresse (optional)",
descriptionLabel: "Beschreibung (optional)",
descriptionA11y: "Beschreibung (optional)",
descriptionPlaceholder: "Zugangshinweise, Phasendetails oder Übergabekontext",
dictate: "Diktieren",
stopDictation: "Stopp",
improving: "Verbesserung...",
improveWithAi: "Mit KI verbessern",
stepBasicsTitle: "Die Grundlagen",
stepBasicsWhy: "Geben Sie dem Standort einen Namen. Mehr ist nicht nötig; der Rest ist optional.",
stepLocationTitle: "Wo ist es?",
stepLocationWhy: "Fügen Sie die Adresse hinzu, damit man ihn findet.",
stepClassifyTitle: "Art des Standorts",
stepClassifyWhy: "Geben Sie an, was für ein Ort es ist und ob er in Betrieb ist.",
stepStructureTitle: "Übergeordneter Standort und Team",
stepStructureWhy: "Ordnen Sie ihn einem größeren Standort zu und wählen Sie das zuständige Team.",
saving: "Wird gespeichert…",
createSite: "Standort anlegen",
parentSiteModalTitle: "Übergeordneter Standort",
managingTeamModalTitle: "Verantwortliches Team",
},
team: {
managingTeam: "Verantwortliches Team",
managingTeamHelper: "Anlagen an diesem Standort übernehmen dieses Team, wenn sie hinzugefügt werden oder wenn Sie es hier ändern.",
selectTeam: "Team auswählen",
optional: "Optional",
pickerTitle: "Verantwortliches Team",
noneAssigned: "Kein Team zugewiesen",
cascadeConfirmTitle: "Anlagen-Teams aktualisieren?",
cascadeConfirmMessage_one: "{{count}} Anlage an diesem Standort wird {{team}} neu zugewiesen.",
cascadeConfirmMessage_other: "{{count}} Anlagen an diesem Standort werden {{team}} neu zugewiesen.",
cascadeConfirmAction: "Team aktualisieren",
updateFailedTitle: "Team konnte nicht aktualisiert werden",
updateFailedMessage: "Versuchen Sie es erneut.",
rowHelper: "Anlagen, die diesem Standort hinzugefügt werden, erben diese Teamzuweisung.",
a11ySelected: "Verwaltungsteam: {{name}}. Team wechseln.",
a11yUnselected: "Wählen Sie das Verwaltungsteam aus, optional",
clearTeam: "Team entfernen",
},
picker: {
dismissA11y: "Standortauswahl schließen",
closeA11y: "Standortauswahl schließen",
searchPlaceholder: "Standorte durchsuchen...",
loadingSites: "Standorte werden geladen",
emptyResults: "Keine Standorte gefunden. Erstellen Sie unten einen oder brechen Sie den Vorgang ab, um zurückzukehren.",
selectItemA11y: "Wählen Sie {{name}}",
},
report: {
placeTitle: "{{place}} · {{site}}",
  generateFailedBody: "Etwas ist schiefgelaufen. Versuchen Sie es in einer Minute erneut.",
  shareFailedTitle: "Bericht konnte nicht gespeichert werden",
  shareGenerated: "Von der KI erstellt am {{date}}. Prüfen Sie ihn, bevor Sie sich darauf verlassen.",
  shareTitle: "Standortbericht: {{name}}",
  pdfDocType: "Standortbericht",
  pdfSummary: "Standortübersicht",
  pdfType: "Standorttyp",
  pdfStatus: "Zustand",
  pdfTeam: "Verantwortliches Team",
  pdfAddress: "Adresse",
  pdfAssetCount: "Anlagen",
  pdfAssetsHeading: "Anlagen an diesem Standort",
  pdfColAsset: "Anlage",
  pdfColType: "Anlagentyp",
  pdfColStatus: "Zustand",
  sharePdf: "Als PDF speichern oder teilen",
  internetResearchHint: "Aus: Der Bericht nutzt nur Ihre eigenen Daten. An: Er sucht auch im Web, zum Beispiel nach Rückrufen für Marke und Modell.",
  internetResearchA11y: "Auch öffentliche Informationen online suchen",
  internetResearch: "Auch öffentliche Informationen online suchen",
loadHistoryFailedTitle: "Der Berichtsverlauf konnte nicht geladen werden",
unknownError: "Unbekannter Fehler",
selectAnalysisTypeTitle: "Wählen Sie mindestens einen Analysetyp aus",
selectAnalysisTypeBody: "Wählen Sie einen oder mehrere Abschnitte aus, bevor Sie den Bericht erstellen.",
generateFailedTitle: "Der Standortbericht wurde nicht erstellt",
summaryPlaceholder: "Erstellen oder laden Sie einen erweiterten Standortbericht, um Portfoliorisiko, Zustand, Konformität und Empfehlungen für alle Anlagen an diesem Standort anzuzeigen.",
actionSelectType: "Wählen Sie mindestens einen Analysetyp aus.",
actionGenerate: "Erstellen Sie den Standortbericht.",
analysisSiteOverview: "Standortübersicht",
analysisAssets: "Anlagen",
analysisMaintenance: "Wartung",
analysisRisk: "Risiko",
analysisHealth: "Gesundheit",
analysisCompliance: "Konformität",
analysisComparisons: "Vergleiche",
contextBadge: "KI-Bericht",
fallbackTitle: "Standortbericht",
metaKind: "KI-Bericht",
heroTitle: "Standortbericht erstellen",
heroSub: "Die KI schreibt einen Bericht aus jeder Anlage an diesem Standort: Inspektionen, Aufträge, Dokumente und Risiko.",
includeAnalysis: "Analyse einschließen",
toggleAnalysisA11y: "{{label}}-Analyse umschalten",
generateButton: "Bericht erstellen",
snapshotComparison: "Frühere Berichte",
latestSnapshotLine: "Neueste: {{date}}",
previousSnapshotLine: "Vorheriges: {{date}}",
noPreviousSnapshot: "Noch kein früherer Bericht.",
insightTitle: "Zusammenfassung des Standortberichts",
signalRisk: "Das Risiko ist {{level}} ({{score}}).",
signalHealth: "Der Zustandswert ist {{status}} ({{score}}).",
signalCompliance: "Konformität ist {{posture}} ({{score}}).",
signalLatestSnapshot: "Zuletzt gespeicherter Bericht: {{date}}.",
signalNoSnapshot: "Es wurde noch kein Bericht gespeichert.",
signalAnalysisSelected_one: "{{count}} Analysetyp ist ausgewählt.",
signalAnalysisSelected_other: "{{count}} Analysetypen sind ausgewählt.",
signalSnapshotsAvailable_one: "{{count}} gespeicherter Bericht ist verfügbar.",
signalSnapshotsAvailable_other: "{{count}} gespeicherte Berichte sind verfügbar.",
signalNoSnapshotsAvailable: "Noch keine gespeicherten Berichte.",
metricSnapshots: "Gespeicherte Berichte",
sourceGenerated: "Von der KI erstellt",
sourceSnapshot: "Zuletzt gespeicherter Bericht",
sourceSetup: "Noch nicht erstellt",
executiveSummary: "Zusammenfassung",
riskHealthCompliance: "Risiko / Gesundheit / Konformität",
riskLine: "Risiko: {{level}} ({{score}})",
healthLine: "Gesundheit: {{status}} ({{score}})",
complianceLine: "Konformität: {{posture}} ({{score}})",
maintenanceService: "Wartung und Service",
recommendations: "Empfehlungen",
recommendationLine: "- {{recommendation}}",
noReportYet: "Noch kein Standortbericht. Tippen Sie auf Bericht erstellen.",
sources: "Quellen",
sourceLine: "- [{{sourceType}}] {{title}}",
},
edit: {
  parentLoopBody: "Ein Standort kann nicht in sich selbst oder in einem seiner eigenen Standorte liegen.",
  parentLoopTitle: "Wählen Sie einen anderen Standort",
  updateFailedBody: "Ihre Änderungen wurden nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  saved: "{{name}} gespeichert.",
pageTitle: "Standort bearbeiten",
unsavedGuardMessage: "Sie haben nicht gespeicherte Änderungen an diesem Standort. Verlassen und Änderungen verwerfen?",
unsavedGuardDiscard: "Verlassen",
unsavedGuardKeep: "Weiter bearbeiten",
updateFailedTitle: "Der Standort konnte nicht aktualisiert werden",
loadErrorTitle: "Dieser Standort konnte nicht geladen werden",
loadErrorWithMessage: "{{message}}. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
loadErrorGeneric: "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
save: "Speichern",
archiveConfirmMessage: "Er wird in Ihren Standorten ausgeblendet. Anlagen bleiben, wo sie sind. Sie finden ihn unter Standorte → Archiviert und können ihn dort wiederherstellen.",
siteNameA11y: "Standortname",
codeA11y: "Kürzel",
descriptionA11y: "Beschreibung",
archiveSite: "Standort archivieren",
    floorArea: "Fläche (m²)",
    floorAreaPlaceholder: "z. B. 2400",
    floorAreaHint: "Wird in ESG für Energie und CO₂ pro m² genutzt. Leer lassen, wenn unbekannt.",
    floorAreaInvalid: "Geben Sie die Fläche als Zahl in Quadratmetern ein.",
},
intake: {
pageTitle: "Ein Problem melden",
errorTitleMissing: "Sagen Sie uns, was passiert.",
errorDescriptionMissing: "Fügen Sie ein paar Details hinzu, damit das Team helfen kann.",
errorNameMissing: "Ihr Name ist erforderlich.",
errorEmailInvalid: "Geben Sie eine gültige E-Mail-Adresse ein.",
errorPhoneInvalid: "Geben Sie eine gültige Telefonnummer für das ausgewählte Land ein.",
errorContactMissing: "Fügen Sie eine E-Mail oder Telefonnummer hinzu, damit das Team antworten kann.",
uploadFailed: "Wir konnten Ihre Fotos nicht hochladen. Entfernen Sie sie oder versuchen Sie es erneut.",
errorNotAvailable: "Dieser Link akzeptiert derzeit keine Anfragen.",
errorSubmitterDetailsRequired: "Bitte fügen Sie Ihren Namen und eine E-Mail-Adresse oder Telefonnummer hinzu.",
errorSubmitGeneric: "Wir konnten Ihre Anfrage nicht senden. Bitte versuchen Sie es erneut.",
contactLabel: "Kontakt",
addressLabel: "Adresse",
linkIncompleteTitle: "Link unvollständig",
linkIncompleteBody: "Dem von Ihnen geöffneten Link fehlt die Anlagenreferenz. Versuchen Sie erneut, den QR-Code zu scannen.",
unavailableTitle: "Dieser Link akzeptiert keine Anfragen",
unavailableBody: "Meldungen sind für diesen Code ausgeschaltet oder der Code ist veraltet. Wenden Sie sich an die Zuständigen vor Ort, z. B. Empfang oder Büro.",
sentTitle: "Danke – Ihre Meldung ist angekommen",
sentBody: "{{company}} hat Ihre Meldung erhalten. Bei Rückfragen meldet man sich per E-Mail oder Telefon. Sie können diese Seite schließen.",
fallbackTeam: "Das Team",
reportAnother: "Ein weiteres Problem melden",
reportAnotherA11y: "Ein weiteres Problem mit dieser Anlage melden",
beforeYouSend: "Bevor Sie senden",
deflectTitle: "Dies könnte das Problem schneller beheben",
deflectIntro_one: "Wir haben einen Leitfaden für diese Anlage gefunden, der Ihr Problem möglicherweise bereits beantwortet. Werfen Sie einen kurzen Blick darauf – vielleicht hilft das schon. Wenn nicht, senden Sie Ihre Anfrage unten.",
deflectIntro_other: "Wir haben {{count}} Anleitungen für diese Anlage gefunden, die Ihr Problem möglicherweise bereits beantworten. Werfen Sie einen kurzen Blick darauf – vielleicht hilft das schon. Wenn nicht, senden Sie Ihre Anfrage unten.",
kbFaq: "FAQ",
kbHowTo: "ANLEITUNG",
collapseGuideA11y: "Reduzieren {{title}}",
expandGuideA11y: "Erweitern Sie {{title}}",
openFullGuide: "Öffnen Sie die vollständige Anleitung",
openGuideA11y: "Anleitung öffnen: {{title}}",
stillSend: "Meine Anfrage trotzdem senden",
stillSendA11y: "Senden Sie meine Anfrage trotzdem",
backToRequest: "Zurück zu meiner Anfrage",
backToRequestA11y: "Gehen Sie zurück, um meine Anfrage zu bearbeiten",
formTitle: "Sagen Sie uns, was passiert",
introWithAsset: "Sie melden ein Problem mit {{assetName}}. ",
introBody: "Das Team wird Ihre Nachricht sehen und sich bei Ihnen melden. Fügen Sie Ihren Namen und eine E-Mail-Adresse oder Telefonnummer hinzu, damit es Sie erreichen kann.",
fieldWhatsHappening: "Was ist los?",
titlePlaceholder: "Einzeilige Zusammenfassung – z.B. „Kein Warmwasser in Einheit 3“",
titleA11y: "Was passiert (erforderlich)",
fieldDetails: "Details",
detailsPlaceholder: "Beschreiben Sie das Problem – was ist nicht in Ordnung, wo und seit wann?",
detailsA11y: "Details (erforderlich)",
fieldPhotos: "Fotos",
photosOptionalHint: "(optional, bis zu 2)",
removePhotoA11y: "Foto entfernen {{index}}",
addPhotoA11y: "Fügen Sie ein Foto hinzu",
addPhotoLabel: "Foto hinzufügen",
fieldYourName: "Ihr Name",
namePlaceholder: "Damit sie wissen, wem sie helfen",
nameA11y: "Ihr Name (erforderlich)",
fieldEmail: "E-Mail",
emailPlaceholder: "Damit sie antworten können",
fieldPhone: "Telefon",
phonePlaceholder: "Für den Fall, dass sie anrufen müssen",
contactHint: "Wir verwenden dies nur, um auf Ihren Bericht zu antworten.",
sending: "Wird gesendet…",
checkingFix: "Suche nach einer schnellen Lösung…",
sendRequest: "Anfrage senden",
},
knowledge: {
  goToAssets: "Zu den Anlagen",
backButton: "Zurück",
title: "Wissen",
subtitle: "Durchsuchen Sie Ihre Anlagen",
unknownAsset: "Unbekannte Anlage",
anyAsset: "Beliebige Anlage",
moreAssetsSummary: "{{first}}, {{second}} +{{count}} mehr",
openItemA11y: "Öffnen Sie {{title}}, {{kind}} auf {{asset}}",
untitledItemA11y: "Wissenselement",
untitled: "Ohne Titel",
searchPlaceholder: "Wissen durchsuchen",
refineResults: "Ergebnisse filtern",
refineTypeLabel: "Typ",
refineAssetLabel: "Anlage",
assetSummaryA11y: "Anlage: {{summary}}",
removeAssetA11y: "{{name}} entfernen",
signInTitle: "Melden Sie sich an, um Ihr Wissen zu durchsuchen",
signInBody: "Ihre Sitzung ist abgelaufen, daher konnte nichts durchsucht werden. Melden Sie sich erneut an, um fortzufahren.",
searchErrorTitle: "Diese Suche konnte nicht ausgeführt werden",
tryAgain: "Erneut versuchen",
noMatchesTitle: "Keine Treffer",
noMatchesBody: "Keine Treffer. Versuchen Sie andere Wörter oder fügen Sie es hinzu: Anlage öffnen, Wissen wählen und auf Hinzufügen tippen.",
noFilterMatchesTitle: "Nichts entspricht diesen Filtern",
filteredEmptyBody_one: "{{count}} Ergebnis passt zur Suche, aber keines passt zur gewählten Anlage oder zum gewählten Typ.",
filteredEmptyBody_other: "{{count}} Ergebnisse passen zur Suche, aber keines passt zur gewählten Anlage oder zum gewählten Typ.",
introTitle: "Durchsuchen Sie Ihre Wissensdatenbank",
introBody: "Finden Sie Anleitungen, FAQs, Notizen, Dateien und Links zu allen Anlagen. Geben Sie mindestens zwei Buchstaben ein. Wissen fügen Sie hinzu, indem Sie eine Anlage öffnen, Wissen wählen und auf Hinzufügen tippen.",
shareOpenLinkFailedTitle: "Link konnte nicht geöffnet werden",
shareInvalidLink: "Ungültiger Link",
shareTimeoutMessage: "Das Laden dieser gemeinsam genutzten Bibliothek dauert zu lange. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
shareLoadFailed: "Gemeinsames Wissen konnte nicht geladen werden",
shareUnableToLoad: "Laden nicht möglich",
shareEmptyTitle: "Nichts zu zeigen",
shareEmptyBody: "Diese Freigabe wurde möglicherweise widerrufen, oder es wurden noch keine Artikel dazu veröffentlicht.",
shareOpenLink: "Link öffnen",
shareOpenFile: "Datei öffnen",
shareClose: "Schließen",
},
  documents: {
    title: "Standortdokumente",
    sub: "Dokumente für das ganze Gebäude, etwa sein EPC oder DEC. Anlagendokumente bleiben bei der jeweiligen Anlage.",
    add: "Dokument hinzufügen",
    open: "Öffnen",
    edit: "Bearbeiten",
    archive: "Archivieren",
    cancel: "Abbrechen",
    archiveTitle: "Dieses Dokument archivieren?",
    archiveBody: "{{title}} verschwindet aus dieser Liste. Datei und Verlauf bleiben erhalten.",
    archiveFailed: "Das Dokument konnte nicht archiviert werden. Bitte erneut versuchen.",
    loadFailed: "Die Dokumente konnten nicht geladen werden.",
    retry: "Erneut versuchen",
    emptyTitle: "Noch keine Standortdokumente",
    emptyBody: "Legen Sie hier die Ausweise des Gebäudes ab, etwa sein EPC oder DEC.",
    validUntil: "Gültig bis {{date}}",
    expired: "Abgelaufen am {{date}}",
  },
};
